// @ts-nocheck
/* eslint-enable */
import { renderToString } from 'react-dom/server';
import React from 'react';
import TotalMonthlyPriceBadge from 'app/shared/modules/TotalMonthlyPrice/TotalMonthlyPriceBadge';
import { shouldShowTotalMonthlyPriceBadge } from 'app/shared/utils/totalMonthlyPriceUtils';
import { listingUtils_bedRange, listingUtils_bathSqFtRange } from 'app/shared/utils/listingUtils';

const controller = {
  getDotMarkerIcon({ marker, isMobile, zoom }) {
    const markerIcon = {
      anchor: { x: 4, y: 2 },
      url: marker,
    };

    if (isMobile) {
      if (zoom >= 15) {
        markerIcon.scaledSize = { width: 10, height: 10 };
      } else if (zoom >= 14) {
        markerIcon.scaledSize = { width: 6, height: 6 };
      } else {
        markerIcon.scaledSize = { width: 3, height: 3 };
      }
    } else {
      if (zoom > 14) {
        markerIcon.scaledSize = { width: 12, height: 12 };
      } else if (zoom === 14) {
        markerIcon.scaledSize = { width: 10, height: 10 };
      } else if (zoom >= 12) {
        markerIcon.scaledSize = { width: 6, height: 6 };
      } else {
        markerIcon.scaledSize = { width: 3, height: 3 };
      }
    }

    return markerIcon;
  },

  listingInfoWindowContent(listing = {}) {
    const hideStreet = listing.address && listing.address.hideStreet;
    const {
      minBeds = 0,
      maxBeds = 0,
      minBaths = 0,
      maxBaths = 0,
      minSqft = 0,
      maxSqft = 0,
    } = listing.listingMinMaxPriceBeds || {};

    const priceDisplay =
      listing.listingMinMaxPriceBeds.priceDisplay === 'Call'
        ? 'Call for price'
        : listing.listingMinMaxPriceBeds.priceDisplay;

    // Beds/baths/sqft — same logic as HdpSummaryDetails
    const rawBedText =
      listing.listingType === 'room'
        ? 'Room for rent'
        : listing.listingType === 'land'
          ? null
          : listingUtils_bedRange(minBeds, maxBeds);
    const bathText = listing.listingType === 'land' ? null : listingUtils_bathSqFtRange(minBaths, maxBaths);
    const sqftText = listingUtils_bathSqFtRange(minSqft, maxSqft);
    const showSqft = (Boolean(minSqft) || Boolean(maxSqft)) && !String(sqftText).includes('-');

    // Build styled detail items: bold dark value + gray label, matching HdpSummaryDetails
    const v = (text) => `<span class="map-popup-detail-value">${text}</span>`;
    const l = (text) => `<span class="map-popup-detail-label">${text}</span>`;

    const detailItems = [
      rawBedText === 'Studio'
        ? `${v('Studio')}`
        : rawBedText === 'Room for rent'
          ? `${v('Room for rent')}`
          : rawBedText
            ? `${v(rawBedText)} ${l(Number(rawBedText) === 1 ? 'Bed' : 'Beds')}`
            : null,
      bathText ? `${v(bathText)} ${l(Number(bathText) === 1 ? 'Bath' : 'Baths')}` : null,
      showSqft ? `${v(sqftText)} ${l('Sqft')}` : null,
    ].filter(Boolean);

    const detailsHtml = detailItems
      .map(
        (item, i) =>
          `<span class="map-popup-detail-item">${item}${i < detailItems.length - 1 ? '<span class="map-popup-detail-sep"> · </span>' : ''}</span>`,
      )
      .join('');

    // Generate TotalMonthlyPriceBadge if conditions are met
    let badgeHtml = '';
    if (shouldShowTotalMonthlyPriceBadge(listing)) {
      try {
        badgeHtml = renderToString(
          React.createElement(TotalMonthlyPriceBadge, {
            listing,
            size: 'sm',
            disableTooltip: true,
          }),
        );
      } catch (error) {
        console.warn('Failed to render TotalMonthlyPriceBadge in map popup:', error);
      }
    }

    const photoUrl = listing.medPhotoUrls?.[0] || listing.medPhotoUrl;

    return `
      <div class="map-popup-content">
        ${photoUrl ? `<img class="map-popup-photo" src="${photoUrl}" alt="" aria-hidden="true" style="width:100%;height:140px;object-fit:cover;display:block;flex-shrink:0;" />` : ''}
        <div class="map-popup-text">
        <div class="map-popup-info-block">
          <div class="map-popup-price-row">
            <span class="map-popup-price">${priceDisplay}</span>
            ${badgeHtml ? `<span class="map-popup-badge">${badgeHtml}</span>` : ''}
          </div>
          ${detailsHtml ? `<div class="map-popup-details">${detailsHtml}</div>` : ''}
        </div>
          <div class="map-popup-address-block">
            <div class="map-popup-address">${hideStreet ? '(Undisclosed Address)' : listing.displayName}</div>
            <div class="map-popup-address">${listing.address?.city || ''}, ${listing.address?.state || ''} ${listing.address?.zip || ''}</div>
          </div>
        </div>
      </div>
    `;
  },
};

export default controller;
